'use client';
import { IconCheck, IconEdit } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { useToggle } from '../hooks';

export const EditableInputV2 = ({
  children,
  label,
  value,
  disabled = false,
  icon,
}: {
  children: ReactNode;
  value: string;
  label: string;
  disabled?: boolean;
  icon: string;
}) => {
  const [edit, toggleEdit] = useToggle();

  const renderIcon = () => {
    if (disabled) {
      return null;
    }

    if (edit) {
      return (
        <div className="w-[24px]">
          <IconCheck
            className="cursor-pointer"
            color="#038747"
            width={24}
            height={24}
            onClick={() => toggleEdit()}
          />
        </div>
      );
    }

    return (
      <div className="w-[24px]">
        <IconEdit
          className="cursor-pointer"
          color="#98a1b4"
          width={24}
          height={24}
          onClick={() => toggleEdit()}
        />
      </div>
    );
  };

  return (
    <div className="w-full bg-[#e8f6ef] rounded-2xl">
      {edit ? (
        <div className="flex w-full gap-4 p-8">
          <div className="w-[24px]">
            <img src={icon} style={{ width: '24px', height: '24px' }} />
          </div>
          <div className="w-full">
            <p className="text-text-secondary font-bold pb-2">{label}: </p>
            {children}
          </div>
          {renderIcon()}
        </div>
      ) : (
        <div className="flex w-full gap-4 p-8">
          <div className="w-[24px]">
            <img src={icon} width={100} height={100} alt="" />
          </div>
          <div className="w-full">
            <p className="text-text-secondary font-bold">{label}: </p>
            <div className="text-text-secondary pt-2">{value}</div>
          </div>
          {renderIcon()}
        </div>
      )}
    </div>
  );
};
